<template>
    <div
        class="relative flex max-h-[224px] flex-col rounded-lg border-2 px-4 py-5 focus:outline-none focus:ring-z-primary-300"
        @click="click"
    >
        <div class="flex items-center gap-2">
            <div class="max-h-[24px]">
                <slot name="logo" />
            </div>

            <h3 class="truncate text-lg font-medium">
                <slot name="name" />
            </h3>
        </div>

        <div>
            <p class="mt-4 line-clamp-3 min-h-[60px] text-left text-sm">
                <slot name="description" />
            </p>
        </div>

        <slot name="cta" />

        <div v-if="!$slots.cta" class="mt-4">
            <div v-if="requiresSub && !hasSub" class="relative">
                <Button
                    type="button"
                    class="w-full"
                    variant="outline"
                    @click.prevent="showProPayment"
                >
                    {{ $t("add") }}</Button
                >
                <svg
                    class="absolute right-2 top-1"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M3.33319 13.3332H12.6665M1.33319 2.6665L3.33319 10.6665H12.6665L14.6665 2.6665L10.6665 7.33317L7.99986 2.6665L5.33319 7.33317L1.33319 2.6665Z"
                        stroke="url(#paint0_linear_1067_2699)"
                        stroke-width="1.4"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <defs>
                        <linearGradient
                            id="paint0_linear_1067_2699"
                            x1="1.00018"
                            y1="1.99976"
                            x2="10.1364"
                            y2="14.5624"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stop-color="#FF8D47" />
                            <stop offset="0.329612" stop-color="#FF8947" />
                            <stop offset="0.534043" stop-color="#FF4247" />
                            <stop offset="0.68692" stop-color="#E92A5B" />
                            <stop offset="0.828171" stop-color="#DD1C67" />
                            <stop offset="1" stop-color="#CF0283" />
                        </linearGradient>
                    </defs>
                </svg>
            </div>

            <div v-if="hasSub || !requiresSub">
                <Button v-if="!selected" class="w-full" variant="outline">
                    {{ $t("add") }}</Button
                >
                <Button v-if="selected" class="w-full" variant="outline">
                    {{ $t("manage") }}</Button
                >
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { Button } from "@/components/ui/button";
import useProDialog from "@/ProModal/composables/useProDialog";
interface Props {
    selected?: boolean;
    requiresSub?: boolean;
    hasSub?: boolean;
}

const emit = defineEmits(["click"]);

const props = withDefaults(defineProps<Props>(), {
    requiresSub: true,
    hasSub: false,
});

const proDialog = useProDialog();

function click(e: Event) {
    if (props.requiresSub && !props.hasSub) {
        e.stopPropagation();
    }
    // emit("click");
}

function showProPayment() {
    proDialog.show({
        feature: "integrations",
    });
}
</script>
